import { render, staticRenderFns } from "./UrunSepetModal.vue?vue&type=template&id=64854dce&scoped=true"
import script from "./UrunSepetModal.vue?vue&type=script&lang=js"
export * from "./UrunSepetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64854dce",
  null
  
)

export default component.exports